import ConditionLayoutProvider from './hooks/useConditionLayout';

import { ConditionLayoutProps } from './@types/ConditionLayoutProps';
import ConditionLayoutContainer from './handles/ConditionLayoutContainer';

const ConditionLayout = (props: ConditionLayoutProps) => {
	return (
		<ConditionLayoutProvider {...props}>
			<ConditionLayoutContainer>{props.children}</ConditionLayoutContainer>
		</ConditionLayoutProvider>
	);
};

export default ConditionLayout;
